import Swal from "sweetalert2";

export const API_BASE_ADMIN = process.env.REACT_APP_API_URL;

export interface MappingRow {
  id: number;
  farm_id: string;
  device_id: string;
  farmer_name: string;
  enterprise_name: string;
}

export interface PaginationMeta {
  total: number;
  total_pages: number;
  page: number;
  page_size: number;
}

export interface EnterpriseOption {
  value: number;
  label: string;
}

export type SearchBy = "farm_id" | "farmer_name";

export const CLIENT_ERROR_MESSAGES: Record<string, string> = {
  INVALID_FILE:        "Only .csv files are accepted.",
  EMPTY_FILE:          "The uploaded CSV file is empty or has no data rows.",
  INVALID_HEADERS:     "Missing required columns: farm_id, device_id.",
  BULK_LIMIT_EXCEEDED: "CSV cannot exceed 500 rows at a time.",
};

export const SERVER_ERROR_MESSAGES: Record<string, string> = {
  INTEGRITY_ERROR:       "A database constraint was violated. Please try again.",
  DB_ERROR:              "A database error occurred. Please try again.",
  INTERNAL_SERVER_ERROR: "An unexpected error occurred. Please try again.",
};

export const showErrorToast = (message: string) =>
  Swal.fire({
    toast: true,
    position: "top-end",
    icon: "error",
    title: message,
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
  });
